// extracted by mini-css-extract-plugin
export var option = "_55-0";
export var optionCard = "_55-f";
export var optionContent = "_55-g";
export var optionIcon = "_55-i";
export var optionIconBox = "_55-h";
export var optionLabel = "_55-j";
export var optionPill = "_55-m";
export var optionPillBadge = "_55-p";
export var optionPillIcon = "_55-n";
export var optionPillLabel = "_55-o";
export var optionRadio = "_55-k";
export var optionRadioInner = "_55-l";
export var optionReveal = "_55-2";
export var optionRevealDelay0 = "_55-3";
export var optionRevealDelay1 = "_55-4";
export var optionRevealDelay10 = "_55-d";
export var optionRevealDelay11 = "_55-e";
export var optionRevealDelay2 = "_55-5";
export var optionRevealDelay3 = "_55-6";
export var optionRevealDelay4 = "_55-7";
export var optionRevealDelay5 = "_55-8";
export var optionRevealDelay6 = "_55-9";
export var optionRevealDelay7 = "_55-a";
export var optionRevealDelay8 = "_55-b";
export var optionRevealDelay9 = "_55-c";
export var optionSelected = "_55-1";